import store from '@/redux/store';
import { resetCartItems } from '@/redux/cart/slice';
import { removeCartItemsFromStorage, removeRentDateFromStorage, removeTotalPriceFromStorage } from '@/utils';
import { setJustPaidFlag } from './justPaidFlag';
import { IBitrixItem } from './paymentItemsBuilder';
import { bitrixPaymentObjectSend } from '@/redux/actions/payment.action';
import { loggerSendingData } from '@/redux/actions/logger.action';

type AppDispatch = typeof store.dispatch;

export async function handleSuccessPayment(
  guid: string,
  items: IBitrixItem[],
  hasGruntReOrder: boolean,
  paymentId: string,
  dispatch: AppDispatch,
  navigation: any,
  setSendingDataTo1C: (value: boolean) => void,
  setPaymentCardLoading: (value: boolean) => void,
  phone: string,
  onError: (error: any) => void
): Promise<void> {
  if (!items || items.length === 0) {
    console.error('No items to process in successPayment');
    onError({
      errorReason: 'Ошибка: отсутствуют товары для оплаты',
      errorType: 'error',
      orderId: paymentId,
    });
    return;
  }

  setSendingDataTo1C(true);
  setPaymentCardLoading(false);

  try {
    await bitrixPaymentObjectSend(guid, items, hasGruntReOrder, paymentId);

    removeCartItemsFromStorage();
    removeRentDateFromStorage();
    removeTotalPriceFromStorage();
    dispatch(resetCartItems());

    await setJustPaidFlag();

    setSendingDataTo1C(false);

    navigation('/payment-success');
  } catch (error: any) {
    console.error('Ошибка отправки данных в 1С:', error);
    setSendingDataTo1C(false);

    try {
      await loggerSendingData({
        type: 'Error1CSending',
        data: {
          message: 'Error sending payment data to 1C',
          error,
          phone,
          items,
          hasGruntReOrder,
        },
      });
    } catch (logError) {
      console.warn('Logger error (non-critical):', logError);
    }

    // При ошибке отправки в 1С показываем ошибку (как в мобильном приложении)
    onError({
      errorReason:
        'Ошибка отправки данных в 1С. Платеж создан, но не обработан. Обратитесь в поддержку с номером платежа: ' +
        paymentId,
      errorType: 'error',
      orderId: paymentId,
    });
  }
}
